export enum CourseType {
  VIDEO = 'video',
  EBOOK = 'ebook',
}
export enum VendorReviewStatus {
  Displayed = 'Displayed',
  Hidden = 'Hidden',
}
